import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ProfileService } from '../../core/services/profile/profile';
import { GroupService } from '../../core/services/group/group';
import { PermissionActions } from '../../core/models/permision.interface';

@Directive({
  selector: '[appPermision]',
  standalone: true,
})
export class PermisionDirective implements OnInit {
  @Input('appPermision') params: string = '';

  constructor(
    private element: ElementRef,
    private profileService: ProfileService,
    private groupService: GroupService,
  ) {}

  ngOnInit() {
    const params = this.params.includes('+') ? this.params.split('+') : [this.params];
    const moduleTarget = params[0];
    const permissions = params.length > 1 ? params[1].split('') : ['r'];
    const profile = this.profileService.getUserProfile();
    const canAccess = permissions.map((permission) =>
      this.groupService.canPerform(moduleTarget, permission as PermissionActions, profile),
    );
    return this.showElement(canAccess.every((el) => el));
  }

  showElement(action: boolean) {
    this.element.nativeElement.style.display = action ? 'initial' : 'none';
  }
}
